import { Button, Col, Form, Modal, Row, Select } from 'antd';
import { FC, useState } from 'react';
import { RiCloseFill } from 'react-icons/ri';
import {
  AddressResponse,
  RentResponse,
  UpdateRentCustomerOrAddressDto,
} from '../../../api/client/data-contracts';
import { useCustomerAddresses, useCustomers } from '../customers/useCustomers';
import { useRents } from './useRents';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

//dayjs.extend(badMutable);
export interface Props {
  open: boolean;
  handleCancel: () => void;
  rent: RentResponse;
}

interface FormModel {
  customer: string;
  delliveryAddress: string;
}

const convertFormModelToDto = (
  formModel: FormModel,
): UpdateRentCustomerOrAddressDto => {
  console.log(formModel);
  const dto: UpdateRentCustomerOrAddressDto = {
    customer: formModel.customer,
    delliveryAddress: formModel.delliveryAddress,
  };

  return dto;
};

export function getAddressString(address: AddressResponse | null) {
  if (!address) {
    return '';
  }
  const addressString = `${address.street}, ${address.postalCodeLocation} ${address.postalCode} ${address.country.description}`;
  return addressString;
}

const UpdateRentCustomerAddress: FC<Props> = (props) => {
  const { updateRentCustomerOrAddress } = useRents();
  const { id } = useParams<{ id: string }>();

  const handleConfirm = (values: FormModel) => {
    const dto = convertFormModelToDto(values);
    updateRentCustomerOrAddress({ rentId: id, dto });
    form.resetFields();
    props.handleCancel();
  };

  const [form] = Form.useForm();

  const initialValues: FormModel = {
    customer: props.rent.customer.id,
    delliveryAddress: props.rent.delliveryAddress.id,
  };
  const [selectedCustomer, setSelectedCustomer] = useState(
    initialValues.customer,
  );
  function handleCustomerChanged(customerId: string) {
    if (customerId !== selectedCustomer) {
      form.setFieldValue('delliveryAddress', undefined);
    }
    setSelectedCustomer(customerId);
  }
  const { customersQuery } = useCustomers();
  const { addressesQuery } = useCustomerAddresses(selectedCustomer);

  const intl = useIntl();

  return (
    <Modal
      title={<h5 className='hp-mb-0'>Editar cliente/morada do aluguer</h5>}
      width={416}
      open={props.open}
      onCancel={props.handleCancel}
      footer={<></>}
      closeIcon={
        <RiCloseFill
          className='remix-icon hp-text-color-black-100 hp-text-color-dark-0'
          size={24}
        />
      }
    >
      <Form
        onFinish={handleConfirm}
        form={form}
        layout='vertical'
        name='basic'
        initialValues={initialValues}
      >
        <Form.Item required label='Cliente' name='customer'>
          <Select
            placeholder='Selecione uma cliente'
            onChange={handleCustomerChanged}
          >
            {customersQuery.data &&
              customersQuery.data.map((customer) => (
                <Select.Option value={customer.id}>
                  {customer.description}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item required label='Morada de entrega' name='delliveryAddress'>
          <Select
            disabled={!selectedCustomer}
            placeholder='Selecione a morada de entrega'
          >
            {addressesQuery.data &&
              addressesQuery.data
                .filter((address) => address.isDelliveryAddress)
                .map((address) => (
                  <Select.Option value={address.id}>
                    {getAddressString(address)}
                  </Select.Option>
                ))}
          </Select>
        </Form.Item>

        <Row>
          <Col md={12} span={24} className='hp-pr-sm-0 hp-pr-12'>
            <Button block type='primary' htmlType='submit'>
              <FormattedMessage id='update' />
            </Button>
          </Col>

          <Col md={12} span={24} className='hp-mt-sm-12 hp-pl-sm-0 hp-pl-12'>
            <Button block onClick={props.handleCancel}>
              {intl.formatMessage({ id: 'cancel' })}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdateRentCustomerAddress;
